import React, {useState} from 'react';
import {AuthenticatedTemplate, UnauthenticatedTemplate} from "@azure/msal-react";
import {useDispatch, useSelector} from "react-redux";
import * as actions from "../../actions/PrintingActions";
import {loadPrintJobs} from "../helper functions/LoadPrintJobs";


export default function PrintNewList() {

    const dispatch = useDispatch()
    let sort = useSelector(state => state.printSortNew);
    let search = useSelector(state => state.printSearchNew);
    const [loading, setLoading] = useState(true);


    return (
        <div>
            <UnauthenticatedTemplate>
                <h5 className="no-access-message"> Sorry, you don't have access to this page! </h5>
            </UnauthenticatedTemplate>

            <AuthenticatedTemplate>
                <div className="page-title-sh26">
                    <h1>Jobs awaiting printing</h1>
                    <p>These are in-progress or pending print jobs</p>
                </div>
                <hr/>

                <div className="dropdown">
                    <div className="dropdown-btn btn-secondary"> Sort by:</div>
                    <div className="dropdown-content">
                        <a onClick={sort => {
                            dispatch(actions.SortNew("INCOMPLETE"))
                        }}>Newest First </a>
                        <a onClick={sort => dispatch(actions.SortOld("INCOMPLETE"))}>Oldest First</a>
                        <a onClick={sort => dispatch(actions.SortAtoZ("INCOMPLETE"))}> A-Z </a>
                    </div>
                </div>

                <div className="search">
                    <input id="search-input" type="text" className="search-box"
                           placeholder="Which job are you looking for?"/>
                    <button className="search-btn btn-secondary btn"
                            onClick={search => dispatch(actions.newSearch(document.getElementById("search-input").value, "INCOMPLETE"))}> 🔍
                    </button>
                </div>

                <div className="page-break"></div>
                <br/>

                <div>
                    {loadPrintJobs(sort, search)}
                </div>

                <div className="page-break"></div>
            </AuthenticatedTemplate>
        </div>
    );
}
